import rootStore from './RootStore';

export * from './context';
export * from './stores';

export default {
  rootStore,
};
